<template>
  <div>
    <aside class="main-aside" :class="{open: this.$store.state.showMobileMenu}">
      <top-logo v-if="this.$store.state.isConfigReady"/>
      <div class="aside-scroll">
        <top-menu :menu="menu" :is-desktop="false"/>
      </div>
    </aside>
    <div class="aside-overlay aside-trigger" @click="toggleMenuState"></div>
  </div>
</template>
<script>
import TopLogo from "@/views/NavigationBar/TopLogo"
import TopMenu from "@/views/NavigationBar/TopMenu";
import {mapMutations} from "vuex";
// import $ from 'jquery';

export default {
  name: 'mobile-menu',
  components: {TopMenu, TopLogo},
  props: {
    menu: {}
  },
  methods: {
    ...mapMutations({
      toggleMenuState: "toggleMenuState"
    })
  }
}
</script>
